import { render, staticRenderFns } from "./dbBuilder.vue?vue&type=template&id=f0afd324"
import script from "./dbBuilder.vue?vue&type=script&lang=js"
export * from "./dbBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports